// 路由切换时滚动到顶部
// - 前进（PUSH/REPLACE）：重置 window 滚动到 0
// - 后退（POP）：放行，浏览器/Capacitor 系统会自己恢复上次的位置
// - 同 pathname 不同 search（如 player 切日期）：不触发，因为依赖只放 pathname
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
	const { pathname } = useLocation();
	const navType = useNavigationType();

	useEffect(() => {
		if (navType === 'POP') return;
		window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
	}, [pathname, navType]);

	return null;
}
